import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Heading from "../../elements/heading";
import Modal from "../../components/Modal";
import BodyText from "../../elements/body-text";
import VerificationMethodPhone from "../../elements/verification-method-phone";
import VerificationMethodEmail from "../../elements/verification-method-email";
import "./style.scss";
import VerifyPhoneNumberForm from "../../sections/verify-phone-number-form";
import VerifyEmailForm from "../../sections/verify-email-form";
import { S_LANG, webStorage } from "../../utils/webStorage";
import { codeTypes } from "../../utils/lynkco-constants";
import { getEmailCode, getSMSCode, checkEmailCode, checkSMSCode, updateMobile } from "../../services/verificationService";
import { getUserInfo, updateEmail } from "../../services/userService";
import { LOGOUT, setUserInfoAction } from "../../redux/actions";

function SelectVerificationMethodModal({
  open,
  logout,
  user,
  type,
  selectVerificationMethodModal,
  verificationMethods,
  onCloseClicked,
  verifyEmailForm,
  verifyMethodSuccess,
  setVerifyMethodSuccess,
  fields,
  verificationMethod,
  setVerificationMethod,
  phoneAreaEntered,
  phoneNumberEntered,
  emailEntered,
  setUpdatedPhoneMessage
}) {
  const [sendCodeFailed, setSendCodeFailed] = useState(false);
  const [verifyCodeFailed, setVerifyCodeFailed] = useState(false);
  const [mobileUpdateFailed, setMobileUpdateFailed] = useState(false);
  const [emailUpdateFailed, setEmailUpdateFailed] = useState(false);
  const [mobileInUse, setMobileInUse] = useState(false);
  const dispatch = useDispatch();
  const setUserInfo = payload => dispatch(setUserInfoAction(payload));

  const hideVerificationModal = () => {
    onCloseClicked();
    setSendCodeFailed(false);
    setVerifyCodeFailed(false);
    setMobileUpdateFailed(false);
    setEmailUpdateFailed(false);
    setMobileInUse(false);
  };
  useEffect(() => {
    if (open) {
      setVerificationMethod(null);
    }
  }, [open]);
  const modalProps = {
    showModal: open,
    onCloseClicked: evt => {
      hideVerificationModal();
    }
  };
  const selectVerificationMethod = async e => {
    let method_id = parseInt(e.currentTarget.getElementsByClassName("verification-method")[0].getAttribute("data-method"));
    let method = verificationMethods.filter(method => {
      return parseInt(method.id) === method_id;
    })[0];
    if (method.type === "phone") {
      await getSMSCode(method.fields.phoneArea, method.fields.phoneNumber, codeTypes.activeAccount);
    }
    if (method.type === "email") {
      await getEmailCode(method.fields.email, codeTypes.activeAccount);
    }
    setVerificationMethod(method);
  };
  const {
    fields: { headingBodyChooseMethod, bodyChooseMethod, emailVerificationLabel, mobileVerificationLabel }
  } = selectVerificationMethodModal;

  const lang = webStorage.get(S_LANG);
  const verifyProps = {
    codeType: codeTypes.updateMobile,
    lang,
    sendCodeFailed,
    verifyCodeFailed,
    submitFailed: mobileUpdateFailed,
    mobileInUse
  };
  const verifyPhoneNumberMethodProps = {
    ...verifyProps,
    ...fields?.verifyPhoneNumberForm?.fields,
    phoneAreaEntered: verificationMethod?.fields?.phoneArea,
    phoneNumberEntered: verificationMethod?.fields?.phoneNumber,
    onVerificationCodeSubmitted: async (evt, data) => {
      setMobileUpdateFailed(false);
      setEmailUpdateFailed(false);
      setVerifyCodeFailed(false);
      try {
        // on verify code success
        await checkSMSCode(verificationMethod?.fields?.phoneArea, verificationMethod?.fields?.phoneNumber, data.code, codeTypes.activeAccount);
        if (type === "phoneChange") {
          await getSMSCode(phoneAreaEntered, phoneNumberEntered, codeTypes.updateMobile);
        }
        if (type === "emailChange") {
          await getEmailCode(emailEntered, codeTypes.updateEmail);
        }
        setVerifyMethodSuccess(true);
      } catch (e) {
        setVerifyCodeFailed(true);
      }
    }
  };
  const verifyNewPhoneNumberProps = {
    ...verifyProps,
    ...fields?.verifyPhoneNumberForm?.fields,
    phoneAreaEntered,
    phoneNumberEntered,
    onVerificationCodeSubmitted: async (evt, data) => {
      setMobileUpdateFailed(false);
      setEmailUpdateFailed(false);
      setVerifyCodeFailed(false);
      try {
        // on verify code success
        await updateMobile(phoneAreaEntered, phoneNumberEntered, data.code, codeTypes.updateMobile);
        const userInfo = await getUserInfo();
        setUserInfo(userInfo);
        hideVerificationModal();
        setUpdatedPhoneMessage(fields?.updateSuccessMessage?.value);
      } catch (e) {
        setVerifyCodeFailed(true);
      }
    }
  };
  const verifyEmailProps = {
    ...verifyEmailForm?.fields,
    submittedEmail: verificationMethod?.fields?.email,
    codeType: codeTypes.updateEmail,
    sendCodeFailed,
    verificationFailed: verifyCodeFailed,
    submitFailed: emailUpdateFailed,
    onVerificationCodeSubmitted: async (evt, data) => {
      setVerifyCodeFailed(false);
      setEmailUpdateFailed(false);
      setMobileUpdateFailed(false);
      try {
        // on verify code success
        const res = await checkEmailCode(verificationMethod?.fields?.email, data.code, codeTypes.activeAccount);
        if (type === "phoneChange") {
          await getSMSCode(phoneAreaEntered, phoneNumberEntered, codeTypes.updateMobile);
        }
        if (type === "emailChange") {
          await getEmailCode(emailEntered, codeTypes.updateEmail);
        }
        setVerifyMethodSuccess(true);
      } catch (ex) {
        setVerifyCodeFailed(true);
      }
    }
  };

  const verifyNewEmailProps = {
    ...verifyEmailForm?.fields,
    submittedEmail: emailEntered,
    codeType: codeTypes.updateEmail,
    sendCodeFailed,
    submitFailed: emailUpdateFailed,
    verificationFailed: verifyCodeFailed,
    onVerificationCodeSubmitted: async (evt, data) => {
      setVerifyCodeFailed(false);
      setEmailUpdateFailed(false);
      setMobileUpdateFailed(false);
      try {
        // on verify code success
        await updateEmail(user.userAccount, user.email, emailEntered, data.code);
        hideVerificationModal();
        logout();
      } catch (ex) {
        setVerifyCodeFailed(true);
      }
    }
  };
  return (
    <Modal className="select-verification-method-modal" {...modalProps}>
      {!verificationMethod && (
        <React.Fragment>
          <Heading type={fields?.headingTypeCode} html={headingBodyChooseMethod} className="select-verification-method-modal-heading" typographyClass="type-h1" />
          <BodyText html={bodyChooseMethod?.value} className="select-verification-method-modal-body" />
          <div className="select-verification-method-modal-methods">
            {verificationMethods.map((method, index) => {
              let methodSection;
              method.type === "phone" &&
                method.fields.phoneArea && method.fields.phoneNumber &&
                (methodSection = <VerificationMethodPhone key={method.id} body={mobileVerificationLabel} phoneArea={method.fields.phoneArea} phoneNumber={method.fields.phoneNumber} method={method.id} onClick={selectVerificationMethod} />);
              method.type === "email" && (methodSection = <VerificationMethodEmail key={method.id} email={method.fields.email} body={emailVerificationLabel} method={method.id} onClick={selectVerificationMethod} />);
              return methodSection;
            })}
          </div>
        </React.Fragment>
      )}
      {verificationMethod?.type === "phone" && !verifyMethodSuccess && (
        <React.Fragment>
          <Heading type={fields?.headingTypeCode} html={fields?.headingBodyCode} className="select-verification-method-modal-heading" typographyClass="type-h1" />
          <VerifyPhoneNumberForm {...verifyPhoneNumberMethodProps} />
        </React.Fragment>
      )}
      {verificationMethod?.type === "email" && !verifyMethodSuccess && (
        <React.Fragment>
          <Heading type={verifyEmailForm?.fields?.headingTypeCode} html={verifyEmailForm?.fields?.headingBodyCode} className="select-verification-method-modal-heading" typographyClass="type-h1" />
          <VerifyEmailForm {...verifyEmailProps} />
        </React.Fragment>
      )}
      {verifyMethodSuccess && type === "phoneChange" && (
        <React.Fragment>
          <Heading type={fields?.headingTypeCode} html={fields?.headingBodyCode} className="select-verification-method-modal-heading" typographyClass="type-h1" />
          <VerifyPhoneNumberForm {...verifyNewPhoneNumberProps} />
        </React.Fragment>
      )}
      {verifyMethodSuccess && type === "emailChange" && (
        <React.Fragment>
          <Heading type={verifyEmailForm?.fields?.headingTypeCode} html={verifyEmailForm?.fields?.headingBodyCode} className="select-verification-method-modal-heading" typographyClass="type-h1" />
          <VerifyEmailForm {...verifyNewEmailProps} />
        </React.Fragment>
      )}
    </Modal>
  );
}
const mapDispatchToProps = dispatch => ({
  logout: () => dispatch({ type: LOGOUT })
});
export default connect(null, mapDispatchToProps)(SelectVerificationMethodModal);
SelectVerificationMethodModal.propTypes = {};
